"use strict";

var teamsAPI = require("app/util/api/team");

var TeamActions = Reflux.createActions({
    "getTeams": {children: ["completed","error"]},
    "addTeam": {children: ["completed","error"]},
    "editTeam": {children: ["completed","error"]},
    "deleteTeam": {children: ["completed","error"]}
});

TeamActions.getTeams.listen(function() {
  teamsAPI.get(
    (teams) => { this.completed(null, teams); },
    (error, response) => { this.error(error, response); }
  );
});

TeamActions.addTeam.listen(function(params, successCallback, errorCallback) {
  teamsAPI.create(params,
    (team) => {
      this.completed(null, team);
      if (typeof successCallback == "function") { successCallback(null, team); }
    },
    (error, response) => {
      this.error(error, response);
      if (typeof errorCallback == "function") { errorCallback(error, response); }
    }
  );
});

TeamActions.editTeam.listen(function(team, successCallback, errorCallback) {
  teamsAPI.update(team,
    () => {
      this.completed(null, team);
      if (typeof successCallback == "function") { successCallback(null, team); }
    },
    (error, response) => {
      this.error(error, response);
      if (typeof errorCallback == "function") { errorCallback(error, response); }
    }
  );
});

TeamActions.deleteTeam.listen(function(team, successCallback, errorCallback) {
  teamsAPI.delete(team,
    () => {
      this.completed(null, team);
      if (typeof successCallback == "function") { successCallback(null, team); }
    },
    (error, response) => {
      this.error(error, response);
      if (typeof errorCallback == "function") { errorCallback(error, response); }
    }
  );
});

module.exports = TeamActions;



// WEBPACK FOOTER //
// ./app/screens/Team/actions/team-actions.js